<template>
  <el-row>
    <el-row>
      <el-col :span="2">
        <h6 style="text-align: left">管辖区域: </h6>
      </el-col>
      <el-col :span="2" :offset="20" v-if="this.$store.state.CurrentUser != 'reader'">
        <el-button size="mini" type="primary" style="margin-bottom: 5px" @click="toggleActivate"><i class="el-icon-plus"></i></el-button>
      </el-col>
    </el-row>

    <el-row style="margin: 10px; border: 1px solid #eee; border-radius: 5px; background-color: #eee" v-if="showAddRegions">
      <el-form ref="form" :model="form" label-width="90px" style="text-align: left; padding: 10px;">
        <el-form-item>
          <el-row>
            <el-col :span="1">区域</el-col>
            <el-col :span="6">
              <el-select v-model="form.province" placeholder="请选择" @change="provinceChanged">
                <el-option
                  v-for="item in provinces"
                  :key="item"
                  :label="nameMappings[item]"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.city" placeholder="请选择" @change="cityChanged">
                <el-option
                  v-for="item in cities"
                  :key="item"
                  :label="nameMappings[item]"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.district" placeholder="请选择">
                <el-option
                  v-for="item in districts"
                  :key="item"
                  :label="nameMappings[item]"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-button type="primary"
                         :disabled="form.city == ''"
                         @click="onAddRegionClick">
                <i class="el-icon-plus"></i> 新增</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-row>
    <el-table
      :data="managedRegions"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="provinceCode"
        label="省名">
        <template slot-scope="scope">
          {{ nameMappings[scope.row.provinceCode] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="cityCode"
        label="市名">
        <template slot-scope="scope">
          {{ nameMappings[scope.row.cityCode] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="districtCode"
        label="区名">
        <template slot-scope="scope">
          {{ nameMappings[scope.row.districtCode] }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button @click="onRemoveRegion(scope.row)" type="danger"><i class="el-delete"></i> 移除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
import * as api from "@/js/api.js"

export default {
  name: "ManagedRegions",
  props: {
    providerId: {
      type: String,
      default: '',
    },
    refreshTimes: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      form: {
        province: '',
        city: '',
        district: '',
        type: 0,
        providerId: '',
      },

      nameMappings: {},
      regionInfo: {},
      provinces: [],
      cities: [],
      districts: [],

      managedRegions: [],
      showAddRegions: false,
    }
  },

  methods: {
    toggleActivate() {
      this.showAddRegions = !this.showAddRegions;
    },

    provinceChanged() {
      this.cities = this.regionInfo.provinceCityMapping[this.form.province]
      this.form.district = ''
      this.form.city = ''
      this.districts = []
    },

    cityChanged() {
      this.districts = this.regionInfo.cityDistrictMapping[this.form.city]
      this.form.district = ''
    },

    onAddRegionClick() {
     this.form.providerId = this.providerId;
     this.form.type = 0;

      const params = {
        provinceCode: this.form.province,
        cityCode:this.form.city,
        districtCode: this.form.district,
        type: 0,
        providerId: this.providerId,
      }

     this.processManagedRegion(params)
    },

    onRemoveRegion(row) {
      const params = {
        provinceCode: row.provinceCode,
        cityCode: row.cityCode,
        districtCode: row.districtCode,
        type: 1,
        providerId: this.providerId,
      }

      this.processManagedRegion(params)
    },

    processManagedRegion(params) {
      api.providerProcessManagedRegion(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error(result.error.message)
        } else {
          this.$message.success('操作成功')
          this.onQuery()
        }
      })
    },

    onQuery() {
      if (this.providerId == '') {
        return
      }

      const query = {
        providerId: this.providerId
      }
      api.providerGetAllManagedRegions(query).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('请求后台服务出错')
        } else {
          this.managedRegions = result.data
        }
      })
    },
  },

  watch: {
    refreshTimes(newVal, oldVal) {
      this.onQuery()
    }
  },

  created() {
    if (this.providerId != '') {
      this.onQuery();
    }
  },

  mounted() {
    let that = this
    if (this.$store.state.RegionInfo) {
      this.regionInfo = this.$store.state.RegionInfo
      this.provinces = this.regionInfo.provinces
      this.nameMappings = this.regionInfo.codeNameMappings
    } else {
      api.getRegions({}).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('请求区域信息出错')
        } else {

          this.regionInfo = result.data
          this.provinces = result.data.provinces
          this.nameMappings = result.data.codeNameMappings

          that.$store.commit('update', ['RegionInfo', this.regionInfo])
        }
      })
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/providers/region/ManagedRegions.vue